"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var react_slick_1 = __importDefault(require("react-slick"));
var classnames_1 = __importDefault(require("classnames"));
var CarGallery = /** @class */ (function (_super) {
    __extends(CarGallery, _super);
    /**
     * @typedef {{ id: string }} Preset
     *
     * @param {{
     *  presets: {
     *    gallery: Preset,
     *    'gallery-full': Preset,
     *    'gallery-thumbnail': Preset
     *  };
     *  images: {
     *    created_at: string,
     *    storage: string,
     *    type: "image" | "video",
     *    url: string
     *  }[];
     *  carouselSlider?: boolean;
     *  fullScreenSlider?: boolean
     * }} props
     */
    function CarGallery(props) {
        var _this = _super.call(this, props) || this;
        /**
         * Универсальная обертка для thumb`очек
         * @param {string} slideClass CSS класс для превьюшки
         * @param {object} opts:
         *  @param {string} url оригинальный URL до картинки
         *  @param {string} presetUrl URL до картинки
         *  @param {boolean} isVideo Флаг того что это превьюшка для видео (лучше анализировать url)
         */
        _this.renderThumb = function (slideClass, opts) {
            var url = opts.url, presetUrl = opts.presetUrl, isVideo = opts.isVideo;
            return (
            // Довольно хитрая верста для того, чтобы изображения разного размера
            // были адаптивными и при этом одинаковыми по высоте.
            react_1.default.createElement("div", { className: slideClass, key: url },
                react_1.default.createElement("div", { className: "azgazui__gallery-thumb-inner" },
                    react_1.default.createElement("div", { className: "azgazui__gallery-thumb-sizer" }),
                    react_1.default.createElement("div", { className: "azgazui__gallery-thumb-absolute" },
                        react_1.default.createElement("img", { src: presetUrl, "data-url": url, onError: _this.errorLoadThumbHandler })),
                    isVideo && react_1.default.createElement("i", { className: "azgazui__gallery-thumb-icon" }))));
        };
        /**
         * Переход к слайду по url
         * @param {string} url
         */
        _this.goToByUrl = function (url) {
            var index = _this.media.findIndex(function (i) { return i.url === url; });
            if (index !== -1) {
                _this.slider1.slickGoTo(index);
            }
        };
        _this.initNavs = function () {
            _this.setState({
                nav1: _this.slider1,
                nav2: _this.slider2,
            });
        };
        _this.initEventListeners = function () {
            document.addEventListener('keydown', _this.handleFullscreenSlider);
        };
        _this.removeEventListeners = function () {
            document.removeEventListener('keydown', _this.handleFullscreenSlider);
        };
        _this.handleFullscreenSlider = function (event) {
            var showFullscreen = _this.state.showFullscreen;
            if (!showFullscreen) {
                return;
            }
            // ESC закрытие слайдера
            if (event.keyCode === 27) {
                _this.switchMode();
            }
            // next слайд
            if (event.keyCode === 39) {
                _this.slider3.slickNext();
            }
            // prev слайд
            if (event.keyCode === 37) {
                _this.slider3.slickPrev();
            }
        };
        _this.switchMode = function () {
            var showFullscreen = _this.state.showFullscreen;
            _this.setState({
                showFullscreen: !showFullscreen,
            });
        };
        _this.switchModeByImgClick = function (e) {
            var isDesktop = document.body.clientWidth >= 768;
            if (e.target.tagName === 'IMG' && isDesktop) {
                _this.switchMode();
            }
        };
        _this.switchModeByBgClick = function (e) {
            if (e.target.dataset.toggle)
                _this.switchMode();
        };
        _this.afterChange = function (index) {
            var media = _this.media;
            var type = media && media[index] && media[index].type;
            _this.setState({
                currentSlide: {
                    index: index,
                    type: type,
                },
            });
        };
        _this.errorLoadThumbHandler = function (evt) {
            var imageDefault = _this.props.imageDefault;
            var dataset = evt.currentTarget.dataset;
            var errorUrl = dataset === null || dataset === void 0 ? void 0 : dataset.url;
            if (imageDefault && (imageDefault === null || imageDefault === void 0 ? void 0 : imageDefault.url) !== errorUrl) {
                _this.replaceToDefaultImage(imageDefault, errorUrl);
            }
        };
        /**
         * Добавляет заглушки для картинок при некорректной ссылке на изображение
         * @param {object} imageDefault img для заглушки изображения
         * @param {string} errorUrl некорректный url картинки
         */
        _this.replaceToDefaultImage = function (imageDefault, errorUrl) {
            var _a = _this.state, images = _a.images, showDefaultImage = _a.showDefaultImage;
            var copyImages = __spreadArrays(images);
            var idxImg = images.findIndex(function (img) { return img.url === errorUrl; });
            if (showDefaultImage) {
                copyImages.splice(idxImg, 1);
            }
            else {
                copyImages.splice(idxImg, 1, imageDefault);
            }
            _this.setState({
                images: copyImages,
                showDefaultImage: true,
            });
        };
        /**
         * Рендерит большие и маленькие слайды с видео
         * @param {array} images
         * @param {string} slideClass
         * @param {string} preset
         */
        _this.renderVideoSlides = function (videos, slideClass) {
            var videoSlides;
            switch (slideClass) {
                case CarGallery.classes.photo:
                    videoSlides = videos.map(function (video) {
                        var id = CarGallery.getYouTubeId(video.url);
                        return (react_1.default.createElement("div", { className: slideClass, key: id }, CarGallery.renderIframe(id)));
                    });
                    break;
                case CarGallery.classes.full:
                    videoSlides = videos.map(function (video) {
                        var id = CarGallery.getYouTubeId(video.url);
                        return (react_1.default.createElement("div", { className: slideClass, key: id, "data-toggle": true },
                            react_1.default.createElement("div", { className: "azgazui__gallery-videoFullscreen" }, CarGallery.renderIframe(id))));
                    });
                    break;
                case CarGallery.classes.thumb:
                    videoSlides = videos.map(function (video) {
                        var id = CarGallery.getYouTubeId(video.url);
                        var presetUrl = "//img.youtube.com/vi/" + id + "/0.jpg";
                        return _this.renderThumb(slideClass, {
                            url: video.url,
                            presetUrl: presetUrl,
                            isVideo: true,
                        });
                    });
                    break;
                default:
                // no default
            }
            return videoSlides;
        };
        /**
         * Рендерит большие и маленькие слайды с картинками
         * @param {array} images
         * @param {string} slideClass
         * @param {string} preset
         */
        _this.renderImageSlides = function (images, slideClass) {
            var imageSlides;
            var preset = _this.preset;
            switch (slideClass) {
                case CarGallery.classes.photo:
                    imageSlides = images.map(function (image) {
                        var presetUrl = image.url + "_" + preset.full; // TODO: add static createPreset(url, preset)
                        return (react_1.default.createElement("div", { className: slideClass, key: presetUrl },
                            react_1.default.createElement("img", { src: presetUrl })));
                    });
                    break;
                case CarGallery.classes.full:
                    imageSlides = images.map(function (image) {
                        var presetUrl = image.url + "_" + preset.full;
                        return (react_1.default.createElement("div", { className: slideClass, key: presetUrl, "data-toggle": true },
                            react_1.default.createElement("img", { src: presetUrl })));
                    });
                    break;
                case CarGallery.classes.thumb:
                    imageSlides = images.map(function (image) {
                        var presetUrl = image.url + "_" + preset.thumb;
                        return _this.renderThumb(slideClass, {
                            url: image.url,
                            presetUrl: presetUrl,
                            isVideo: false,
                        });
                    });
                    break;
                default:
                // no default
            }
            return imageSlides;
        };
        /**
         * Возвращает ReactNode с слайдами соответствующего класса
         * @param {array} media Картинки и видео в перемешку
         * @param {string} slideClass Класс отпределяет клаcc и тип слайда одновременно
         * @param {string} preset Определяет размер картинки. Не актуально для видео слайдов.
         */
        _this.renderSlides = function (slideClass) {
            var _a = _this, images = _a.images, videos = _a.videos;
            var imageSlides = _this.renderImageSlides(images, slideClass);
            var videoSlides = _this.renderVideoSlides(videos, slideClass);
            return __spreadArrays(imageSlides, videoSlides);
        };
        _this.state = {
            nav1: null,
            nav2: null,
            showFullscreen: false,
            images: _this.props.images,
            showDefaultImage: false,
            currentSlide: {
                index: 0,
                type: 'image',
            },
        };
        return _this;
    }
    CarGallery.getYouTubeId = function (url) {
        var search = new URLSearchParams(url.split('?')[1]);
        var id = search.get('v');
        return id;
    };
    /**
     * Возвращает ReactNode
     * @param {string} id Идентификатор видео
     * @returns {ReactNode} iframe
     */
    CarGallery.renderIframe = function (id) {
        return (react_1.default.createElement("div", { className: "azgazui__gallery-videoWrapper" },
            react_1.default.createElement("iframe", { title: id, src: "https://www.youtube.com/embed/" + id, frameBorder: "0", allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture", allowFullScreen: true })));
    };
    CarGallery.prototype.componentDidMount = function () {
        this.initNavs();
        this.initEventListeners();
    };
    CarGallery.prototype.componentWillUnmount = function () {
        this.removeEventListeners();
    };
    Object.defineProperty(CarGallery.prototype, "images", {
        get: function () {
            var media = this.state.images;
            return media.filter(function (m) { return m.type === 'image'; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CarGallery.prototype, "videos", {
        get: function () {
            var media = this.state.images;
            return media.filter(function (m) { return m.type === 'video'; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CarGallery.prototype, "media", {
        get: function () {
            var _a = this, images = _a.images, videos = _a.videos;
            return __spreadArrays(images, videos);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CarGallery.prototype, "preset", {
        get: function () {
            var presets = this.props.presets;
            var full = presets["gallery-full"].id, thumb = presets["gallery-thumbnail"].id;
            return {
                full: full,
                thumb: thumb,
            };
        },
        enumerable: false,
        configurable: true
    });
    CarGallery.prototype.render = function () {
        var _this = this;
        var _a = this.props, fullScreenSlider = _a.fullScreenSlider, carouselSlider = _a.carouselSlider;
        var _b = this.state, images = _b.images, nav1 = _b.nav1, nav2 = _b.nav2, showFullscreen = _b.showFullscreen, currentSlide = _b.currentSlide;
        var slides = this.renderSlides(CarGallery.classes.photo);
        var thumbs = this.renderSlides(CarGallery.classes.thumb);
        var fulls = this.renderSlides(CarGallery.classes.full);
        return (react_1.default.createElement("div", { className: classnames_1.default('azgazui__gallery-slider', "azgazui__gallery-" + currentSlide.type, {
                'azgazui__gallery-show-fullScreenSlider': fullScreenSlider,
            }, {
                'azgazui__gallery-show-carouselSlider': carouselSlider,
            }) },
            react_1.default.createElement("div", { className: "azgazui__gallery-img-wrap", onClick: this.switchModeByImgClick },
                react_1.default.createElement(react_slick_1.default, __assign({ ref: function (s) {
                        _this.slider1 = s;
                    } }, (carouselSlider && { asNavFor: nav2 }), { className: "azgazui__gallery-img", dotsClass: "azgazui__gallery-dots", afterChange: this.afterChange, responsive: [
                        {
                            breakpoint: 768,
                            settings: {
                                dots: true,
                            },
                        },
                        {
                            breakpoint: 992,
                            settings: {
                                dots: false,
                            },
                        },
                        {
                            breakpoint: 10000,
                            settings: {
                                dots: false,
                                swipe: false,
                                fade: true,
                            },
                        },
                    ] }), slides)),
            fullScreenSlider && showFullscreen && (react_1.default.createElement("div", { className: "azgazui__gallery-fullscreen-wrap", onClickCapture: this.switchModeByBgClick },
                react_1.default.createElement(react_slick_1.default, { ref: function (s) {
                        _this.slider3 = s;
                    }, className: "azgazui__gallery-fullscreen", speed: 200, initialSlide: currentSlide.index, responsive: [
                        {
                            breakpoint: 992,
                            settings: {
                                swipe: true,
                            },
                        },
                        {
                            breakpoint: 10000,
                            settings: {
                                swipe: false,
                                fade: true,
                            },
                        },
                    ] }, fulls),
                react_1.default.createElement("button", { className: "azgazui__gallery-fullscreen-close", type: "button", onClick: this.switchMode }, "\u0417\u0430\u043A\u0440\u044B\u0442\u044C"))),
            carouselSlider && (react_1.default.createElement(react_slick_1.default, { ref: function (s) {
                    _this.slider2 = s;
                }, className: classnames_1.default('azgazui__gallery-preview', {
                    unslicked: images.length <= CarGallery.previewCount,
                }), asNavFor: nav1, slidesToShow: Math.min(images.length, CarGallery.previewCount), focusOnSelect: true, swipeToSlide: true }, thumbs))));
    };
    CarGallery.previewCount = 4;
    CarGallery.classes = {
        photo: 'azgazui__gallery-photo',
        thumb: 'azgazui__gallery-thumb',
        full: 'azgazui__gallery-fullscreen-photo',
    };
    return CarGallery;
}(react_1.PureComponent));
exports.default = CarGallery;
CarGallery.displayName = 'CarGallery';
CarGallery.propTypes = {
    presets: prop_types_1.default.shape({
        gallery: prop_types_1.default.shape({ id: prop_types_1.default.string }),
        'gallery-full': prop_types_1.default.shape({ id: prop_types_1.default.string }),
        'gallery-thumbnail': prop_types_1.default.shape({ id: prop_types_1.default.string }),
    }).isRequired,
    images: prop_types_1.default.arrayOf(prop_types_1.default.object),
    imageDefault: prop_types_1.default.object,
    carouselSlider: prop_types_1.default.bool,
    fullScreenSlider: prop_types_1.default.bool,
};
CarGallery.defaultProps = {
    images: [],
    carouselSlider: true,
    fullScreenSlider: true,
};
